export { default as budgetReducer, duckActions as budgetActions } from './budget'
export { default as newsReducer, duckActions as newsActions} from './news'
export { default as statsReducer, duckActions as statsActions } from './stats'
export { default as reportsReducer, duckActions as reportsActions } from './reports'
export { default as pageReducer, duckActions as pageActions } from './page';



// WEBPACK FOOTER //
// ./src/reducks/index.js